import { render, staticRenderFns } from "./Method_Statement.vue?vue&type=template&id=68cefa88&scoped=true&"
import script from "./Method_Statement.vue?vue&type=script&lang=js&"
export * from "./Method_Statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cefa88",
  null
  
)

export default component.exports